import type { SnNetworkChartProperties } from "../../tsp-output/types";
import { dimDesc, measureDesc } from "./strings";

export default function data() {
  return {
    targets: [
      {
        path: "/qHyperCubeDef",
        dimensions: {
          min: 3,
          max: 4,
          description: (_properties: SnNetworkChartProperties, index: number) => dimDesc[index] ?? "",
        },
        measures: {
          min: 0,
          max: 3,
          description: (_properties: SnNetworkChartProperties, index: number) => measureDesc[index] ?? "",
        },
      },
    ],
  };
}
